import React from 'react';
import { useParams } from 'react-router-dom';

import { useQuery } from '../../hooks/useQuery';
import { useI18n } from '../../hooks/useI18n';

import Header from '../../components/Header';

import './style.scss';

export default function ExternalErrorPage() {
  const { code = 'GENERIC_ERROR' } = useParams();
  const query = useQuery();
  const { t } = useI18n();

  const onBackButtonClickHandler = () => {
    window.history.go(-2);
  };

  return (
    <div className="ExternalErrorPage">
      <Header onBackButtonClick={onBackButtonClickHandler} />
      <div className="ExternalErrorPage__details">
        <img src={require("./../../client/assets/logo.png")} alt="VTR" />
        <h1>{t("ExternalErrorPage.title")}</h1>
        <p>
          {t("ExternalErrorPage.codePrefix")}
          {code}
        </p>
        <p>{query.get("message") || t("ExternalErrorPage.defaultMessage")}</p>
      </div>
    </div>
  );
}